module.exports = "img/sound-indicator.ac4bf8d.svg";